module.exports = __webpack_public_path__ + "assets/img/ijj_qrcode.eda03356.png";